import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { getShopifyCollections } from "@redotech/redo-merchant-app-common/client/shopify";
import { getBigcommerceCollections } from "./bigcommerce";
import { getCommentsoldCollections } from "./commentsold";
import { getMivaCollections } from "./miva";

/**
 * Searches collections across all supported platforms and returns deduped
 * names. A failure for any single platform is logged and skipped.
 */
export async function searchAllPlatformCollectionNames(
  client: RedoMerchantClient,
  {
    searchString,
    signal,
  }: { searchString: string | undefined; signal?: AbortSignal },
): Promise<string[]> {
  const [
    shopifyCollections,
    commentsoldCollections,
    bigcommerceCollections,
    mivaCollections,
  ] = await Promise.all([
    searchPlatformCollections("Shopify", () =>
      getShopifyCollections(client, { searchString, signal }),
    ),
    searchPlatformCollections("CommentSold", () =>
      getCommentsoldCollections(client, { searchString, signal }),
    ),
    searchPlatformCollections("BigCommerce", () =>
      getBigcommerceCollections(client, { searchString, signal }),
    ),
    searchPlatformCollections("Miva", () =>
      getMivaCollections(client, { searchString, signal }),
    ),
  ]);

  return Array.from(
    new Set([
      ...shopifyCollections.map((collection) => collection.name),
      ...commentsoldCollections.map((collection) => collection.name),
      ...bigcommerceCollections.map((collection) => collection.name),
      ...mivaCollections.map((collection) => collection.name),
    ]),
  );
}

async function searchPlatformCollections<Collection>(
  platform: string,
  search: () => Promise<Collection[]>,
): Promise<Collection[]> {
  try {
    return await search();
  } catch (error) {
    console.error(`Unable to fetch ${platform} collections`, error);
    return [];
  }
}
